import React from 'react';
import c from 'classnames';
import s from './Description.scss';
const Description = ({ children, className })=>/*#__PURE__*/ React.createElement("p", {
        className: c(s['root'], className)
    }, children);
Description.displayName = 'Description';
export default Description;
